module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/join/step-screen-2-e66a3706c7c6b6d6d9fb60226e5be8c8.png";